import { useState, useEffect } from 'react';
import { throttleToAnimationFrame } from '@utils/common';

/**
 * Provides info about whether the user has currently scrolled down the page or
 * not.
 */
function useScrolledDown(options = {
  minScrollOffsetPx: 50
}) {
  const [scrolledDown, setScrolledDown] = useState(false);
  useEffect(() => {
    const handleScroll = throttleToAnimationFrame(() => {
      setScrolledDown(window.pageYOffset >= options.minScrollOffsetPx);
    });
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [options.minScrollOffsetPx]);
  return scrolledDown;
}

export { useScrolledDown };
//# sourceMappingURL=useScrolledDown.js.map
